import CitySEOHead from "@/components/feature/CitySEOHead";
import AlexandriaLAHeroSection from "./components/HeroSection";
import AlexandriaLAStickyNav from "./components/StickyNav";
import AlexandriaLAProcessingTimeSection from "./components/ProcessingTimeSection";
import AlexandriaLAServicesSection from "./components/ServicesSection";
import AlexandriaLALocalAreaSection from "./components/LocalAreaSection";
import AlexandriaLATestimonialsSection from "./components/TestimonialsSection";
import AlexandriaLAAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AlexandriaLAComparisonSection from "./components/ComparisonSection";
import AlexandriaLAMistakesSection from "./components/MistakesSection";
import AlexandriaLAHowItWorksSection from "./components/HowItWorksSection";
import AlexandriaLAFAQSection, { faqs } from "./components/FAQSection";
import AlexandriaLAHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AlexandriaLAFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import AlexandriaLATravelTimingSection from "./components/TravelTimingSection";
import AlexandriaLADestinationsSection from "./components/DestinationsSection";

const alexandriaLaFaqs = faqs as { q: string; a: string }[];

const alexandriaLaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function AlexandriaLAPage() {
  return (
    <>
      <CitySEOHead
        city="Alexandria"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/alexandria-la"
        title="Emergency Passport Alexandria, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Alexandria, LA — as fast as 24 hours. Serving medical professionals, Fort Johnson military families, and LSUA students in Rapides Parish. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Alexandria, Louisiana"
        geoPosition="31.3113;-92.4452"
        faqs={alexandriaLaFaqs}
        servicesSchema={alexandriaLaServices}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <div className="font-sans">
        <AlexandriaLAHeroSection />
        <AlexandriaLAStickyNav />
        <AlexandriaLAProcessingTimeSection />
        <AlexandriaLALocalAreaSection />
        <AlexandriaLAServicesSection />
        <AlexandriaLATravelTimingSection />
        <AlexandriaLADestinationsSection />
        <AlexandriaLATestimonialsSection />
        <AlexandriaLAAcceptanceFacilitiesSection />
        <AlexandriaLAComparisonSection />
        <AlexandriaLAMistakesSection />
        <AlexandriaLAHowItWorksSection />
        <AlexandriaLAFAQSection />
        <AlexandriaLAHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/alexandria-la" state="LA" />
        <AlexandriaLAFinalCTA />
      </div>
    </>
  );
}